import React from "react";
import { Slide, Fade } from "react-awesome-reveal";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";

const Donation = () => {
  return (
    <div className="min-h-screen flex items-center bg-gradient-to-br from-green-50/50 via-white to-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">
        {/* Responsive Video Container */}
        <div className="lg:col-span-6 w-full">
          <Fade triggerOnce>
            <div className="relative overflow-hidden rounded-2xl shadow-xl bg-black border border-gray-100 aspect-video group">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=A1qlpNkoZHM"
                width="100%"
                height="100%"
                controls
                light={true} // Modern feature: Loads thumbnail first, speeds up initial page load
              />
            </div>
          </Fade>
        </div>

        {/* Text Content */}
        <div className="lg:col-span-6 w-full flex flex-col justify-center">
          <Slide direction="right" triggerOnce>
            <div>
              {/* Subtle Tagline */}
              <span className="text-sm font-semibold tracking-wider uppercase text-green-700 block mb-3">
                Make an Impact
              </span>

              <h2 className="text-4xl sm:text-5xl font-extrabold text-green-950 tracking-tight mb-8">
                Benefits of Donation
              </h2>

              {/* Styled Quote Block */}
              <div className="border-l-4 border-green-800 pl-4 my-6 italic bg-green-50/50 py-4 pr-4 rounded-r-xl">
                <p className="text-xl sm:text-2xl text-gray-800 font-serif leading-relaxed">
                  “Charity extinguishes sin like water extinguishes fire”
                </p>
                <cite className="text-sm font-medium text-green-900 block mt-3 not-italic tracking-wide">
                  — Prophet Muhammad (Peace be upon Him)
                </cite>
              </div>

              <p className="text-gray-600 leading-relaxed mb-8 max-w-lg">
                Your generosity provides vital resources and transforms
                communities. Join our growing community of supporters dedicated
                to making a lasting difference.
              </p>

              {/* Modern Action Button */}
              <div>
                <Link
                  to="/membership"
                  className="inline-block text-center px-8 py-3.5 bg-green-950 text-white font-medium rounded-full hover:bg-green-800 transition-all duration-300 transform hover:-translate-y-0.5 shadow-md hover:shadow-lg w-full sm:w-auto"
                >
                  Become a Member
                </Link>
              </div>
            </div>
          </Slide>
        </div>
      </div>
    </div>
  );
};

export default Donation;
